import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { UtilCommon } from '../common/utils/UtilCommon';

/**
 * Sanitizes HTML content using DOMPurify before rendering
 * @deprecated Consider using Angular's default sanitization with pre-processed content
 * 
 * SECURITY NOTE: This pipe uses DOMPurify for sanitization, then bypasses Angular's
 * built-in security. While safer than the old string replacement approach, it's still
 * recommended to let Angular handle sanitization when possible.
 */
@Pipe({ name: 'keepHtmlExtend', pure: false })
export class KeepHtmlExtendPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {
    }

    transform(content: any): SafeHtml | string {
        if (!content) return '';
        
        // Use DOMPurify via UtilCommon for proper HTML sanitization
        const sanitized = UtilCommon.sanitizeHtml(content);
        
        // Safe to bypass Angular sanitization after DOMPurify processing
        return this.sanitizer.bypassSecurityTrustHtml(sanitized);
    }
}

/**
 * @deprecated Legacy implementation - DO NOT USE
 * Kept for reference and comparison only
 * 
 * SECURITY WARNING: This implementation is VULNERABLE to XSS attacks:
 * - Uses simple string replacement (easily bypassed)
 * - Case-sensitive matching
 * - No DOM parsing
 * - No type validation
 * 
 * Examples of bypasses:
 * - <scr<script>ipt>alert(1)</script> → becomes <script>alert(1)</script>
 * - <IMG ONERROR=alert(1)> → passes through (case-sensitive)
 * - Type confusion: ['<script>alert(1)</script>'] → bypass
 */
export class KeepHtmlExtendPipe_Backup implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {
    }

    transform(content) {
        content = content.replaceAll('<script', '');
        content = content.replaceAll('<script>', '');
        content = content.replaceAll('onerror', '');
        content = content.replaceAll('onclick', '');
        content = content.replaceAll('onload', '');
        content = content.replaceAll('alert(', '');
        content = content.replaceAll('console', '');
        content = content.replaceAll('onchange', '');
        content = content.replaceAll('onmouseover', '');
        content = content.replaceAll('onmouseout', '');
        content = content.replaceAll('onkeydown', '');
        content = content.replaceAll('onkeypress', '');
        content = content.replaceAll('onkeyup', '');
        content = content.replaceAll('javascript', '');
        content = content.replaceAll('eval', '');
        content = content.replaceAll('jquery', '');
        content = content.replaceAll('$', '');
        content = content.replaceAll('atob', '');
        content = content.replaceAll('btob', '');
        return this.sanitizer.bypassSecurityTrustHtml(content);
    }
}
